module.exports = __webpack_public_path__ + "static/img/17.f00e39e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/17.png
// module id = zJ3n
// module chunks = 0